import React, {PureComponent} from 'react';

import './Timeline.scss';

export default class Timeline extends PureComponent {
  render() {
    return <div className={`timeline ${this.props.className || ''}`}>
      <div className="bar" />
      {this.props.children}
    </div>;
  }
}
